import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../shared/directives/focus-me.directive';

@Component({
	selector: 'copo-sold-to-changed-confirmation-dialog',
	templateUrl: './sold-to-changed-confirmation-dialog.component.html',
	styleUrl: './sold-to-changed-confirmation-dialog.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class SoldToChangedConfirmationDialogComponent {
	claimedBatch: string | undefined;
	claimedModificationDate: string | undefined;
	constructor(

		public dialogRef: MatDialogRef<SoldToChangedConfirmationDialogComponent>,
	) {}

	changeSoldTo(event: boolean) {
		this.dialogRef.close(event);
	}
}
